import React from 'react';
import { Toaster } from 'react-hot-toast';
import { Outlet } from 'react-router-dom';

const AuthLayout = (): JSX.Element => {
  // const user = useSelector(selectUsuario);

  return (
    <div className="h-screen">
      <Outlet />

      <Toaster />
    </div>
  );
};

export default AuthLayout;
